import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "./apiRequest";
import { isTokenExpired } from "../../Utils/Utils";
import { logOut, raiseError } from "../actions/action";


const addToCart = createAsyncThunk('add/cart', async (cartDetail, { dispatch }) => {
  if (!isTokenExpired()) {
    try {
      const response = await apiRequest.patch(`/cart`, cartDetail);
      return response.data;
    } catch (error) {
      dispatch(raiseError("Something went wrong. please try after sometime"));
      return;
    }
  }
  dispatch(logOut());
  dispatch(raiseError("Plase login again"))
});

export { addToCart };